import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Validator from '../../utils/validate';

export default function PhongBanDialog(props) {
    const [updateModel, setUpdateModel] = React.useState(props.model);
    const [errors, setErrors] = React.useState({});
    const updateTimer = React.useRef(null);
    
    const rules = [
        {
          field: 'name',
          method: 'isEmpty',
          validWhen: false,
          message: 'Vui lòng nhập.',
        },
        {
          field: 'name',
          method: 'isLength',
          args: [{min: 5}],
          validWhen: true,
          message: 'Vui lòng nhập ít nhất 3 kí tự',
        },
        {
          field: 'maHRM',
          method: 'isEmpty',
          validWhen: false,
          message: 'Vui lòng nhập.',
        },
        {
            field: 'maHRM',
            method: 'isLength',
            args: [{min: 4}],
            validWhen: true,
            message: 'Vui lòng nhập ít nhất 4 kí tự',
        },
        {
            field: 'maHRM',
            method: 'matches',
            args: [/^[0-9]{1,3}(.{1}[0-9]{1,3}){1,7}$/],
            validWhen: true,
            message: 'Mã HRM không đúng định dạng',
        }
    ];

    React.useEffect(() => {
        if(!updateTimer.current) {
          setUpdateModel(props.model)
        }
    }, [props.model]);

    const validator = new Validator(rules);
    const save = () => {
        // validate
        const errors = validator.validate(updateModel);
        setErrors(errors);
        if (!validator.isValid) {
            return;
        }
        // create object
        if (updateModel.id) {
            props.service.update(updateModel).then((rs) => {
                setUpdateModel(rs);
                props.onCreated(rs);
            }).catch((ex) => {
                console.log(ex);
            });
        } else {
            props.service.create(updateModel).then((rs) => {
                setUpdateModel(rs);
                props.onCreated(rs);
            }).catch((ex) => {
                console.log(ex);
            });
        }
    }

    const handleInput = (e) => {
        let model = {...updateModel};
        model[e.target.name] = e.target.value;
        setUpdateModel(model);
    };

    return (
        <Dialog fullWidth={true} open={props.open} onClose={props.onClose}>
            <DialogTitle>{!updateModel.id ? "Thêm mới " : "Chỉnh sửa "} {updateModel.loai}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    name='name'
                    label="Tên"
                    type="email"
                    fullWidth
                    variant="standard"
                    value={updateModel.name}
                    onChange={handleInput}
                    error={errors.name}
                    helperText={errors.name}
                />
                <TextField
                    margin="dense"
                    id="maHRM"
                    name='maHRM'
                    label="Mã HRM"
                    type="email"
                    fullWidth
                    variant="standard"
                    value={updateModel.maHRM}
                    onChange={handleInput}
                    error={errors.maHRM}
                    helperText={errors.maHRM}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Đóng</Button>
                <Button onClick={save}>Thêm mới</Button>
            </DialogActions>
        </Dialog>
    );
}